import React, {
  forwardRef,
  memo,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
} from "react";
import { useDispatch, useSelector } from "react-redux";
import { chefActions } from "../../store/chefSlice";
import { S3_MENU_FOLDER } from "../../store/constants";
import { fetchDishBand } from "../../store/menuActions";
import "./exploreStory.css";
import { ToastContainer, toast } from "react-toastify";
import { menuActions } from "../../store/menuSlice";
import { bottomBarActions } from "../../store/bottomBarSlice";
import mixpanel from "mixpanel-browser";
import {
  getDisplayChefTimeLabel,
  getTodayDateValue,
} from "../../utils/timeHelper";
import moment from "moment";
import ReactPixel from "react-facebook-pixel";
import ImageLoader from "../chef/ImageLoader";
import { addDish, removeDish, updatePortion } from "../../store/cartActions";
// import clevertap from "clevertap-web-sdk";
import {
  calculateCurrentPrice,
  combineTheDate,
  isMobileDevice,
} from "../../utils/helper";
import "react-lazy-load-image-component/src/effects/blur.css";
import AudioSvg from "../../assets/ReactSvg/AudioSvg";
import AudioMuteSvg from "../../assets/ReactSvg/AudioMuteSvg";
import Joyride from "react-joyride";
import PlayIconSvg from "../../assets/ReactSvg/PlayIconSvg";
import PauseSvg from "../../assets/ReactSvg/PauseSvg";
import ChefCardSkeleton from "../ChefListScreen/ChefCardSkeleton";
import { ControlBar, Player } from "video-react";
import { uniq } from "lodash";
import { useSwiperSlide } from "swiper/react";
import VolumeHighSvgIcon from "../../assets/ReactSvg/VolumeHighSvgIcon";
import VolumeSlashSvgIcon from "../../assets/ReactSvg/VolumeSlashSvgIcon";
import AddCartIconSvg from "../../assets/ReactSvg/AddCartIconSvg";
import StarFourIconSvg from "../../assets/ReactSvg/StarFourIconSvg";
import TimerSvgIcon from "../../assets/ReactSvg/TimerSvgIcon";
import CuiratoExploreIconSvg from "../../assets/ReactSvg/CuiratoExploreIconSvg";
import classNames from "classnames";
import SwipeUpIconSvg from "../../assets/ReactSvg/SwipeUpIconSvg";
import MinusIconSvg from "../../assets/ReactSvg/MinusIconSvg";
import AddIconSvg from "../../assets/ReactSvg/AddIconSvg";
import { storieAction } from "../../store/storieSlice";
import GuideOverlayTap from "./GuideOverlay/GuideOverlayTap";
import { Tooltip } from "antd";
import { useOutsideClick } from "../../hooks/useOutsideClick";
import useVideoMuted from "../../hooks/useVideoMuted";
// import "video-react/dist/video-react.css"; // import css

const VideoPlayer = memo(
  ({
    videoUrl,
    isVideoActiveOnScreen,
    isPaused,
    action,
    loaded,
    isVideoReadyToPlay,
    setIsVideoReadyToPlay,
    onReady,
    imageLoaded,
    isPlaying: isPlayingVideo,
    seekTimeRef,
    seekTime,
    setSeekTime,
    swiper,
    exploreIndex,
    isMuted,
    setIsMuted,
    playerRef,
  }) => {
    const playPauseBtnRef = useRef(null);
    const [isPlaying, setIsPlaying] = useState(false);
    const [isReady, setIsReady] = useState(false);

    const isMutedRef = useRef(isMuted);
    isMutedRef.current = isMuted;

    const applyMute = () => {
      const player = playerRef.current;
      if (!player) return;
      player.actions?.mute(isMutedRef.current);
      const el = player.video?.video;
      if (el) el.muted = isMutedRef.current;
    };

    useEffect(() => {
      applyMute();
    }, [isMuted, isVideoActiveOnScreen]);

    useEffect(() => {
      setIsPlaying(isPlayingVideo);
    }, [isPlayingVideo]);

    const handleReady = () => {
      onReady();
      imageLoaded();
    };

    // useEffect(() => {
    //   handleReady();
    // }, []);

    const handlePlayPause = () => {
      const player = playerRef.current;
      if (isPlaying) {
        player.pause();
        action("pause");
      } else {
        player.play();
        action("play");
      }
      setIsPlaying(!isPlaying);
    };

    useEffect(() => {
      const player = playerRef?.current;
      if (!player) return;
      if (isPaused) {
        player.pause();
        action("pause");
        setIsPlaying(false);
      } else {
        player.play();
        action("play");
        setIsPlaying(true);
      }
    }, [isPaused]);

    useEffect(() => {
      const player = playerRef?.current;
      if (!player) return;
      if (isVideoActiveOnScreen) {
        player.play();
        setIsPlaying(true);
      } else {
        player.pause();
      }
    }, [isVideoActiveOnScreen]);

    const handlePlay = () => {
      setIsVideoReadyToPlay(true);
    };

    useEffect(() => {
      const player = playerRef?.current;
      if (!player) return;

      const handleReadyStateChange = () => {
        applyMute();
        handlePlay();
        setIsReady(true);
        handleReady();
      };

      const handleTimeUpdate = () => {
        if (player.currentTime >= 2) {
          player.pause();
          setIsPlaying(false);
        }
      };

      const videoElement = player.video.video;

      videoElement.addEventListener("loadeddata", handleReadyStateChange);
      videoElement.addEventListener("timeupdate", handleTimeUpdate);

      return () => {
        videoElement.removeEventListener("loadeddata", handleReadyStateChange);
        videoElement.removeEventListener("timeupdate", handleTimeUpdate);
      };
    }, []);

    const src = videoUrl;

    return (
      <div>
        {!isVideoReadyToPlay && (
          <div>
            <ChefCardSkeleton darkMode />
          </div>
        )}
        <div>
          <div style={{ position: "relative" }} className="player-wrapper">
            {/* <button
              id={`muteBtn-${exploreIndex}`}
              class="btn-play-pause react-player-mute-unmute-button exploreSoundIcon"
              onClick={handleMuteUnmute}
              style={{ background: "transparent", border: "0px" }}
            >
              <span style={{ height: 20, width: 20 }} id={`iconMute-${exploreIndex}`}>
                {!isMuted ? <VolumeSlashSvgIcon /> : <VolumeHighSvgIcon />}
              </span>
            </button> */}
            {/* <button
              onClick={handlePlayPause}
              id={`playPauseBtn-${exploreIndex}`}
              className="btn-play-pause react-player-play-pause-button"
              ref={playPauseBtnRef}
              title="Play/Pause"
            >
              <span id={`iconPlayPause-${exploreIndex}`}>
                {!isPlaying ? <PlayIconSvg /> : <PauseSvg />}
              </span>
            </button> */}
            <div className="explore-video-player">
              <div className="videoContainer" id="videoContainer">
                <Player
                  ref={playerRef}
                  src={src}
                  // muted={!isVideoActiveOnScreen}
                  autoPlay={true}
                  width="100%"
                  playsInline
                ></Player>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
);

const ExploreStory = forwardRef((props, ref) => {
  const {
    exploreIndex,
    name,
    headers,
    isActive,
    dishSpecialType,
    dishInfo,
    chefName,
    chefId,
    action,
    isPaused,
    storyImages,
    labels,
    labelDesc,
    swiper,
    setShowWaitListScreen,
    muteAllPlayers,
    unmuteAllPlayers,
    dishKey,
    run,
    setRun,
  } = props;

  const chefTimeData = useSelector((state) => state.chef.chefTime);
  const currentChefsTime = chefTimeData[chefId];
  const swiperIndexSelector = useSelector((store) => store.storie.swiperIndex);
  const swiperSlide = useSwiperSlide();
  const runJoyrideSelector = useSelector((store) => store.storie.runJoyride);
  const exploreTooltipFlavour = useSelector(
    (store) => store.storie.exploreTooltipFlavour
  );
  const { cartData, scheduleTime, isScheduleNow } = useSelector(
    ({ cart }) => cart
  );
  const playerRef = useRef(null);
  const scheduleDateTime = combineTheDate(
    scheduleTime?.date,
    scheduleTime?.time
  );
  const currentDishCount =
    cartData?.find((order) => order._id === dishInfo._id)?.portion || 0;
  const menuCartDataInfo = cartData.find(
    (c) => (c.dishId || c._id) === dishInfo._id
  );
  const user = useSelector(({ auth }) => auth.user);
  const loggedIn = user.phonenumber ? true : false;
  const isServiceable = useSelector((state) => state.auth.isServiceable);
  const chefList = useSelector((state) => state.chef.chefList);
  const currentChefDetails = chefList.find((c) => c._id === chefId) || {};
  const isDishAddedToCart = cartData
    .map((cart) => cart._id)
    ?.includes(dishInfo._id);
  const cartChefIds = cartData.map((a) => a.chefId);
  const allCartChefList =
    chefList
      ?.filter((a) => cartChefIds.includes(a._id))
      ?.map((c) => c.kitchenId) || [];
  const discountType = loggedIn
    ? user.maxDishes > user.totalDishesBooked
      ? "deepDiscount"
      : "normal"
    : "deepDiscount";

  const dispatch = useDispatch();
  const isVideoActiveOnScreen = swiperIndexSelector === exploreIndex;
  const isNext = swiperIndexSelector + 1 === exploreIndex;
  const isPrev =
    swiperIndexSelector > exploreIndex &&
    swiperIndexSelector <= exploreIndex + 10;

  const [currentPrice, setCurrentPrice] = useState(0);
  const currentPriceRef = useRef();
  const seekTimeRef = useRef(0);
  const DEMO_EXPLORE = [
    "SHOW_CHEF_INFO_ONLY",
    "DISH_NAME",
    "DISH_CAPTION",
    "CHEF_CARD",
  ].includes(labelDesc?.highlightedText);
  const joinWaitlist = labelDesc?.highlightedText === "JOIN_WAITLIST";
  const [loaded, setLoaded] = useState(false);
  const [isMuted, setIsMuted] = useVideoMuted();
  const [isVideoReadyToPlay, setIsVideoReadyToPlay] = useState(false);
  const [seekTime, setSeekTime] = useState(0);
  const [isVisible, setIsVisible] = useState(false);
  const [isDescriptionExpanded, setIsDescriptionExpanded] = useState(false);
  const mastTextRef = useRef(null);
  const [mastTextHeight, setMastTextHeight] = useState(0);

  useImperativeHandle(ref, () => ({
   mute: () => setIsMuted(true),
    unMute: () => setIsMuted(false),
  }));

  const handleMenuClick = () => {
    // TODOWAITLIST: remove
    // return;
    dispatch(menuActions.setCurrentChefIdClicked(props.chefId));
    dispatch(menuActions.setChefInfoDefaultKey(1));
    dispatch(bottomBarActions.loadTab({ tabName: "chefListScreen" }));
    mixpanel.track("go-to-menu-clicked explore");
    // clevertap.event.push("go-to-menu-clicked explore");
  };

  const addToCard = (dishId, extraPrice = 0, customizeObj = []) => {
    const currentChef = chefList.find((chef) => chef._id === props.chefId);
    if (
      [...uniq(allCartChefList)].length &&
      ![...uniq(allCartChefList)].includes(currentChef.kitchenId)
    ) {
      //already added chef kitchen location
      toast.error("Please order from one restaurant at a time");
      return;
    }
    mixpanel.track(`explore add to cart clicked`);
    // clevertap.event.push(`explore add to cart clicked`);
    const isDishAdded = cartData.find((cart) => cart._id === dishId);
    if (isDishAdded && isDishAdded.isAddedOnDiscount) {
      toast.error("You can't add more portions for the discount price.");
      return;
    }
    if (false) {
      //if (!user.userid) {
      dispatch(bottomBarActions.loadTab({ tabName: "account" }));
    } else {
      let totalDiscountedDishesAdded = 0;
      cartData.forEach((cart) => {
        if (cart.isAddedOnDiscount == true) {
          totalDiscountedDishesAdded += 1;
        }
      });

      let isDiscountAllowed =
        user.totalDishesBooked + totalDiscountedDishesAdded < user.maxDishes;

      let isAddedOnDiscount =
        isDiscountAllowed && user.maxDishes !== 0 ? true : false;
      const payload = {
        cartPayload: {
          userId: user.userid,
          dishId: dishId,
          dealPrice: currentPrice + extraPrice,
          customizeObj: customizeObj,
          isAddedOnDiscount: isAddedOnDiscount,
          price: dishInfo.price,
          portion: currentDishCount + 1,
        },
        dish: { ...dishInfo, portion: currentDishCount + 1 },
        maxDishes: user.maxDishes,
        isFromCart: false,
        actionType: "ADD",
      };
      if (payload?.cartPayload?.portion < 1) {
        toast.error("Please add portion");
        return;
      }
      if (currentDishCount === 0) {
        dispatch(addDish(payload));
      } else {
        const cartDishInfo = cartData?.find((cart) => cart._id === dishId);
        payload.cartId = cartDishInfo.cartId;
        payload.cartPayload.dealPrice = menuCartDataInfo.dealPrice;
        dispatch(updatePortion(payload));
      }

      if (props.setShowAddedItemPopup) {
        props.setShowAddedItemPopup(true);
      }
    }
    mixpanel.track("added-to-cart");
    // clevertap.event.push("added-to-cart");
    ReactPixel.track("AddToCart");
  };

  const onRemoveDish = async (dishId) => {
    const payload = {
      userId: user.userid,
      dishId: dishId,
      isActive: false,
      maxDishes: user.maxDishes,
      dealPrice: menuCartDataInfo.dealPrice,
      isFromCart: false,
    };
    let totalDiscountedDishesAdded = 0;
    let isDiscountAllowed =
      user.totalDishesBooked + totalDiscountedDishesAdded < user.maxDishes;
    let isAddedOnDiscount =
      isDiscountAllowed && user.maxDishes !== 0 ? true : false;

    if (currentDishCount > 1) {
      const payload = {
        cartPayload: {
          userId: user.userid,
          dishId: dishId,
          dealPrice: currentPrice,
          isAddedOnDiscount: isAddedOnDiscount,
          price: dishInfo.price,
          portion: currentDishCount - 1,
        },
        dish: { ...dishInfo, portion: currentDishCount - 1 },
        maxDishes: user.maxDishes,
        isFromCart: false,
        actionType: "REMOVE",
      };
      const cartDishInfo = cartData?.find((cart) => cart._id === dishId);
      payload.cartId = cartDishInfo.cartId;
      payload.cartPayload.dealPrice = menuCartDataInfo.dealPrice;
      dispatch(updatePortion(payload));
    } else {
      payload.dealPrice = menuCartDataInfo.dealPrice;
      const cartId = cartData?.find((cart) => cart._id === dishId)?.cartId;
      if (cartId) {
        payload.cartId = cartId;
      }
      dispatch(removeDish(payload));
    }
    mixpanel.track("dish-removed");
    // clevertap.event.push("dish-removed");
  };

  const onChefNameClick = () => {
    // return; // TODOWAITLIST: remove
    dispatch(menuActions.setCurrentChefIdClicked(props.chefId));
    dispatch(menuActions.setChefInfoDefaultKey(2));
    dispatch(bottomBarActions.loadTab({ tabName: "chefListScreen" }));
  };

  useEffect(() => {
    if (!props.id) return;
    dispatch(fetchDishBand(props.id));
  }, [dispatch]);

  useEffect(() => {
    if (!loaded && isVideoActiveOnScreen) {
      action("pause");
    }
  }, [loaded, isVideoActiveOnScreen]);

  useEffect(() => {
    if (!isPaused && !loaded) {
      action("pause");
    }
  }, [isPaused, loaded]);

  useEffect(() => {
    if (loaded && isVideoActiveOnScreen) {
      if (dishKey !== 0 || props.img.includes("mp4")) {
        action("play");
      }
    }
  }, [loaded, isVideoActiveOnScreen]);

  const handleTouchStart = (e) => {
    e?.preventDefault();
    action("next");
  };

  useEffect(() => {
    if (dishKey === 0) {
      const left = document.getElementById(`left-touch-zone${exploreIndex}`);
      const right = document.getElementById(`right-touch-zone${exploreIndex}`);

      if (left) {
        left.addEventListener("touchstart", handleTouchStart, {
          passive: false,
        });
      }
      if (right) {
        right.addEventListener("touchstart", handleTouchStart, {
          passive: false,
        });
      }

      return () => {
        if (left) {
          left.removeEventListener("touchstart", handleTouchStart);
        }
        if (right) {
          right.removeEventListener("touchstart", handleTouchStart);
        }
      };
    }
  }, [exploreIndex]);

  useEffect(() => {
    if (!isVideoActiveOnScreen) {
      action("pause");
    }
  }, [isVideoActiveOnScreen]);

  const imageLoaded = (time = 0) => {
    setTimeout(() => {
      setLoaded(true);
    }, time);
  };

  const getStatusClassname = () => {
    if (!isServiceable) {
      return "chef-non-serviciable";
    } else if (todayChefSchedule?.online) {
      return "chef-online";
    } else {
      return "chef-away";
    }
  };
  const capitalize = (str) =>
    str ? str[0].toUpperCase() + str.slice(1).toLowerCase() : "";
  const isScheduleOrder = !isScheduleNow && moment(scheduleDateTime).isValid();
  const currentPriceValue = calculateCurrentPrice(
    dishInfo,
    currentChefsTime,
    currentChefDetails,
    isScheduleOrder,
    discountType,
    dishSpecialType
  );

  useEffect(() => {
    const isScheduleOrder =
      !isScheduleNow && moment(scheduleDateTime).isValid();
    const currentPriceValue = calculateCurrentPrice(
      dishInfo,
      currentChefsTime,
      currentChefDetails,
      isScheduleOrder,
      discountType,
      dishSpecialType
    );
    if (!!currentPriceRef?.current) return;
    if (currentPriceValue === currentPriceRef?.current) return;
    setCurrentPrice(currentPriceValue);
    currentPriceRef.current = currentPriceValue;
  }, [
    isScheduleNow,
    scheduleDateTime,
    dishInfo,
    currentChefsTime,
    currentChefDetails,
    user.maxDishes,
    user.totalDishesBooked,
  ]);

  const todayChefSchedule = getTodayDateValue(
    currentChefDetails?.schedules || []
  );

  const textOutput = getDisplayChefTimeLabel(todayChefSchedule);
  const percentageDiscount =
    ((props.price - currentPriceValue) / props.price) * 100;

  const exploreFirstScreen = exploreIndex === 0 && dishKey === 0;

  const handleMuteUnmute = () => {
    setIsMuted(!isMuted);
  };

  const onReady = () => {
    imageLoaded(500);
  };

  const exploreImageLoaded = () => {
    setLoaded(true);
    setIsVideoReadyToPlay(true);
  };

  const handleAddToCartClick = () => {
    // if (DEMO_EXPLORE || joinWaitlist) {
    //   mixpanel.track("landing_explore-join-waitlist-btnclick");
    //   setShowWaitListScreen(true);
    // } else {
    //   addToCard(dishInfo._id);
    // }

     dispatch(menuActions.setIsMenuClicked(true));
        dispatch(bottomBarActions.loadTab({ tabName: "menu" }));
        dispatch(chefActions.onMenuClick(chefId));
        dispatch(bottomBarActions.updateFrom({ from: "explore" }));
        dispatch(chefActions.onMenuCategorieId(chefId));
  };

  const handleDescPress = () => {
    if (isDescriptionExpanded) {
      setIsDescriptionExpanded(false);
      action("play");
    } else {
      setIsDescriptionExpanded(true);
      action("pause");
    }
  };

  const labelsArrayList =
    dishSpecialType !== "DEMO_EXPLORE"
      ? labels.filter((a) => a.key)
      : dishInfo.headerArrayList;

  const showChefInfo = labelDesc.highlightedText === "SHOW_CHEF_INFO_ONLY";
  const dishNameHighlight = labelDesc.highlightedText === "DISH_NAME";
  const CHEF_CARD = labelDesc.highlightedText === "CHEF_CARD";
  const DISH_CAPTION = labelDesc.highlightedText === "DISH_CAPTION";

  const dishDescription = labelDesc?.desc || labelDesc?.demoDesc;

  const handleOutside = () => {
    console.log("Clicked outside exploreFirstScreen1");
    dispatch(storieAction.setExploreTooltipFlavour(false));
  };

  const exploreTooltipFlavourRef = useOutsideClick(handleOutside);

  //   useEffect(() => {
  //   if (mastTextRef.current) {
  //     const height = mastTextRef.current.getBoundingClientRect().height;
  //     console.log('height @@@@@', height)
  //     setMastTextHeight(height);
  //   }
  // }, [dishDescription, isVideoActiveOnScreen]);

  useEffect(() => {
    // Ensure animation applies after initial render
    dispatch(storieAction.setRunJoyride(false));
    if (dishNameHighlight) {
      setTimeout(() => setIsVisible(true), 100);
    }
  }, []);

  const getMediaUrl = (path) =>
    path.includes("https://cuirato-images.s3.ap-south-1.amazonaws.com")
      ? path
      : S3_MENU_FOLDER + path;

  const mediaUrl = getMediaUrl(props.img);

  return (
    <div className="image-container_wrapper">
      <div
        style={{ position: "absolute", top: "0px", height: "100%" }}
        className="image-container"
      >
        {(isVideoActiveOnScreen || isNext || isPrev) && (
          <>
            {props.img.includes("mp4") ? (
              <VideoPlayer
                videoUrl={mediaUrl}
                isVideoActiveOnScreen={isVideoActiveOnScreen}
                swiper={swiper}
                action={action}
                loaded={loaded}
                isActive={isVideoActiveOnScreen}
                isPlaying={isVideoActiveOnScreen && !isPaused}
                isPaused={isPaused}
                onReady={onReady}
                imageLoaded={imageLoaded}
                seekTimeRef={seekTimeRef}
                seekTime={seekTime}
                setSeekTime={setSeekTime}
                isVideoReadyToPlay={isVideoReadyToPlay}
                setIsVideoReadyToPlay={setIsVideoReadyToPlay}
                exploreIndex={exploreIndex}
                isMuted={isMuted}
                setIsMuted={setIsMuted}
                playerRef={playerRef}
              />
            ) : (
              <img
                src={mediaUrl}
                className={classNames("story-image-container", {
                  "story-image-container-zoom": showChefInfo,
                  "story-image-container-zoom-animation": dishNameHighlight,
                })}
                loading="lazy"
                onLoad={exploreImageLoaded}
                style={{ height: "100vh", objectFit: "cover" }}
              />
            )}
            {storyImages.map((img, index) => {
              return (
                <React.Fragment key={index}>
                  {!!!img.includes("mp4") && (
                    <img
                      src={getMediaUrl(img)}
                      loading="lazy"
                      className="hide-story-image"
                    />
                  )}
                </React.Fragment>
              );
            })}
          </>
        )}
      </div>
      {!loaded && (
        <>
          <ImageLoader className="loader_wrapper explore_loader_wrapper" />
        </>
      )}
      <div
        className={`exploreChefScreen ${isVideoReadyToPlay ? "show" : "hide"}`}
      >
        <div className="swiper_Top explore_swiper_Top">
          {props.img.includes("mp4") && (
            <button
              id="muteBtn"
              // id={`muteBtn-${exploreIndex}`}
              className="btn-play-pause react-player-mute-unmute-button exploreSoundIcon"
              onClick={handleMuteUnmute}
              style={{ background: "transparent", border: "0px" }}
            >
              <span
                style={{ height: 20, width: 20 }}
                id="iconMute"
                // id={`iconMute-${exploreIndex}`}
              >
                {isMuted ? <VolumeSlashSvgIcon /> : <VolumeHighSvgIcon />}
              </span>
            </button>
          )}
        </div>
        {isDescriptionExpanded && (
          <div
            className="swiper_Top explore_swiper_Top exploreTopOverlayTap"
            onClick={() => {
              setIsDescriptionExpanded(false);
              action("play");
            }}
          ></div>
        )}

        {(DEMO_EXPLORE || joinWaitlist) && (
          <div
            style={{ padding: "25px 3px 3px 0px" }}
            className="swiper_Top explore_swiper_Top"
          >
            <div
              style={{ width: 100, height: 30, paddingLeft: 10 }}
              className="swiper_Title"
            >
              <CuiratoExploreIconSvg />
            </div>

            <div className="">
              <div className="exploreCenterHeaderWrapper">
                {labelDesc?.exploreCenterHeader && (
                  <div className="exploreCenterHeaderText">
                    {labelDesc?.exploreCenterHeader}
                  </div>
                )}
                {labelDesc?.exploreCenterLabel && (
                  <div className="exploreCenterLabelText">
                    {labelDesc?.exploreCenterLabel}
                  </div>
                )}
                {labelDesc?.exploreCenterHeader1 && (
                  <div className="exploreCenterHeaderText">
                    {labelDesc?.exploreCenterHeader1}
                  </div>
                )}
              </div>
            </div>
          </div>
        )}

        <div
          className={classNames("swipper_bottom explore_swipper_bottom", {
            explore_chefinfo_swipper_bottom: showChefInfo || dishNameHighlight,
            show: dishNameHighlight && isVisible,
          })}
        >
          <div
            style={!!labelDesc?.demoLabel ? { height: 140 } : {}}
            className="explore-swipper_bottom"
          >
            {exploreIndex === 0 && dishSpecialType === "DEMO" && (
              <>
                {!!labelDesc.key && (
                  <Joyride
                    disableScrollParentFix={true}
                    continuous={true}
                    scrollToFirstStep={true}
                    showProgress={false}
                    showSkipButton={false}
                    // steps={steps}
                    run={runJoyrideSelector}
                    disableOverlay={true}
                    hideBackButton={true}
                    disableScrolling={true}
                    styles={{
                      options: {
                        arrowColor: "#F8EDD5",
                        primaryColor: "#e8814d",
                        zIndex: 10000,
                        backgroundColor: "#F8EDD5",
                        overlayColor: "rgba(0, 0, 0, 0.6)",
                      },
                      tooltip: {
                        width: "350px",
                      },
                      tooltipTitle: {
                        fontSize: 16,
                        margin: "0 0 0px 0",
                        textAlign: "left",
                        paddingLeft: "10px",
                        color: "#670000",
                      },
                      tooltipContent: {
                        fontSize: 13,
                        padding: "10px 10px",
                        textAlign: "left",
                        fontWeight: 300,
                        color: "#670000",
                      },
                      buttonNext: {
                        fontSize: "13px",
                      },
                    }}
                  />
                )}
              </>
            )}

            {/* <div
              className={classNames("exploreDishNameTitleWrapper", {
                hideOpacityText:
                  DEMO_EXPLORE && labelDesc?.highlightedText !== "DISH_NAME",
              })}
            >
              <span
                className={classNames("exploreDishNameTitle Satoshi", {
                  exploreDishNameTitleBold:
                    DEMO_EXPLORE && labelDesc?.highlightedText === "DISH_NAME",
                })}
              >
                {headers || labelDesc?.dishNameHeader}
              </span>
              <span
                className={classNames("exploreDishNameTitleLabel Satoshi", {
                  exploreDishNameTitleLabelBold:
                    DEMO_EXPLORE && labelDesc?.highlightedText === "DISH_NAME",
                })}
              >
                {dishInfo?.matchPercent && `(${dishInfo?.matchPercent} Match)`}
              </span>
            </div>
             */}
            <div
              className={classNames("chef-info-name-wrapper", {
                hideOpacityText:
                  DEMO_EXPLORE && labelDesc?.highlightedText !== "CHEF_CARD",
              })}
            >
              <div
                onClick={onChefNameClick}
                className="swiper_Title_img explore_swiper_Title_img"
              >
                <img src={currentChefDetails?.chefImgTh} className="storyImg" />
              </div>
              <div>
                <p
                  onClick={onChefNameClick}
                  className={classNames("explore-chef-label Satoshi", {
                    "explore-text-bold": CHEF_CARD,
                  })}
                >
                  Chef {chefName}
                </p>
                <div className="chef-time-wrapper">
                  <TimerSvgIcon />
                  <span
                    className={classNames("explore-chef-timing-label", {
                      "explore-text-bold": CHEF_CARD,
                    })}
                  >
                    {textOutput}
                  </span>
                </div>
              </div>
              {/* <button
                onClick={handleMenuClick}
                className={classNames("explore-story-menu-button", {
                  "explore-text-bold": CHEF_CARD,
                })}
              >
                Menu
              </button> */}
            </div>
            <div
              // style={
              //   isDescriptionExpanded
              //     ? { overflow: "hidden" }
              //     : { height: 58, overflow: "hidden" }
              // }
              className="ingrident-list-wrapper"
            >

              {/* {!!labelDesc.key && (
                <div className={classNames("ingrident-list-header-label")}>
                  {labelsArrayList.map((l, index) => {
                    return (
                      <div key={index}>
                        {exploreFirstScreen && index === 1 ? (
                          <Tooltip
                            title="Tap on the screen to read the next detail about the dish"
                            open={exploreTooltipFlavour}
                            color="#ffffff"
                            rootClassName="tooltipExploreGuiderootClassName"
                          >
                            <span
                              className={classNames({
                                "ingrident-list-header-label-active Satoshi":
                                  l.key === labelDesc.key,
                                "ingrident-list-header-label-active-bold":
                                  DISH_CAPTION && l.key === labelDesc.key,
                                ["exploreFirstScreen1"]:
                                  exploreFirstScreen && index === 1,
                              })}
                              ref={
                                index === 1 && exploreFirstScreen
                                  ? exploreTooltipFlavourRef
                                  : null
                              }
                            >
                              {capitalize(l.key)}
                            </span>
                          </Tooltip>
                        ) : (
                          <span
                            className={classNames({
                              "ingrident-list-header-label-active Satoshi":
                                l.key === labelDesc.key,
                              "ingrident-list-header-label-active-bold":
                                DISH_CAPTION && l.key === labelDesc.key,
                              ["exploreFirstScreen0"]:
                                exploreFirstScreen && index === 0,
                              ["exploreFirstScreen1"]:
                                exploreFirstScreen && index === 1,
                              ["exploreFirstScreen2"]:
                                exploreFirstScreen && index === 2,
                              ["exploreFirstScreen3"]:
                                exploreFirstScreen && index === 3,
                            })}
                          >
                            {capitalize(l.key)}
                          </span>
                        )}

                        {index + 1 < labels.length && <StarFourIconSvg />}
                      </div>
                    );
                  })}
                </div>
              )} */}
              
              <div
                className={classNames({
                  "label-desc demo Satoshi": labelDesc?.demoDesc,
                  "label-desc Satoshi": !labelDesc?.demoDesc,
                  hideOpacityText:
                    DEMO_EXPLORE &&
                    labelDesc?.highlightedText !== "DISH_CAPTION",
                  "explore-text-bold":
                    (DEMO_EXPLORE &&
                      labelDesc?.highlightedText === "DISH_CAPTION") ||
                    joinWaitlist,
                })}
                onClick={handleDescPress}
                style={
                  isDescriptionExpanded
                    ? { overflow: "hidden" }
                    : { height: 35, overflow: "hidden" }
                }
              >
                <div
                  className={classNames({
                    ["mast__text"]: isVideoActiveOnScreen,
                  })}
                  ref={mastTextRef}
                  onAnimationEnd={() => {
                    if (mastTextRef.current) {
                      const height =
                        mastTextRef.current.getBoundingClientRect().height;

                      setMastTextHeight(height - 35);
                    }
                  }}
                >
                  {dishDescription.split(" ").map((word, index) => (
                    <span
                      key={index}
                      style={{ animationDelay: `${index * 0.15}s` }}
                    >
                      {word}&nbsp;
                    </span>
                  ))}
                </div>
              </div>
              {!isDescriptionExpanded && mastTextHeight > 0 && (
                <div
                  className="ingrident-list-wrapper-readmore"
                  onClick={handleDescPress}
                >
                  …more
                </div>
              )}
            </div>
            
            {false && (!!currentPriceValue || props.price) && (
              <div className="explore_swipper_bottom_first">
                <div className={classNames({ hideOpacityText: DEMO_EXPLORE })}>
                  <div className="items_value">
                    <div className="plus_taxes">
                      <h5 className="explore-deal-price-wrapper">
                        <span className="explore-deal-price Satoshi">
                          {`₹${
                            currentPriceValue > 0
                              ? currentPriceValue
                              : props.price
                          }`}
                        </span>

                        {currentPriceValue > 0 &&
                          currentPriceValue !== props.price && (
                            <span className="price-strike explore-price-strike Satoshi">
                              {`₹${props.price}`}
                            </span>
                          )}
                      </h5>
                    </div>
                  </div>
                </div>
                <div
                  className={classNames("explore-addcart_btn", {
                    hideOpacityText: DEMO_EXPLORE,
                  })}

                >
                  {!isDishAddedToCart ? (
                    <button className="Satoshi" onClick={handleAddToCartClick}>
                      {/* <AddCartIconSvg /> */}
                      <span className="explore-addcart_btn_text">
                        {/* {DEMO_EXPLORE || joinWaitlist
                          ? "Join Waitlist"
                          : "Add to cart"} */}
                          Menu
                      </span>
                    </button>
                  ) : (
                    <div
                      style={{ background: "#fff" }}
                      className="dishCartEditBtn"
                    >
                      <button
                        className="dishCartAddToCartBtn transparentBtn dish-cart-add-no-style-btn"
                        onClick={() => onRemoveDish(dishInfo._id)}
                      >
                        <MinusIconSvg />
                      </button>
                      <div className="dishTotalCartAddedDishCount Satoshi">
                        {currentDishCount}
                      </div>
                      <button
                        className="dishCartRemoveToCartBtn transparentBtn dish-cart-add-no-style-btn"
                        onClick={() => addToCard(dishInfo._id)}
                      >
                        <AddIconSvg />
                      </button>
                    </div>
                  )}
                </div>
                {joinWaitlist && isMobileDevice() && (
                  <div className="swipeUpBottomBtn">
                    <div className="swipeUpBottomBtnContent">
                      <SwipeUpIconSvg />
                      <span>swipe up for more recipes</span>
                    </div>
                  </div>
                )}
              </div>
            )}
            
          </div>
        </div>
      </div>
      <ToastContainer limit={1} />
      {/* {exploreFirstScreen && (
        <Joyride
          // disableScrollParentFix={true}
          // continuous={true}
          // scrollToFirstStep={true}
          // showProgress={true}
          // showSkipButton={true}
          // floaterProps={{ getPopper: () => {},disableFlip: true }}
          disableCloseOnEsc={true}
          disableOverlay={true}
          disableOverlayClose={true}
          steps={steps}
          run={true}
          className="joyridePopupTransparent"
          styles={{
            options: {
              arrowColor: "transparent",
              primaryColor: "transparent",
              zIndex: 10000,
              backgroundColor: "transparent",
              overlayColor: "rgba(255, 255, 255, 0.9)",
              height: "50%",
            },
            tooltip: {
              width: "350px",
              opacity: 0
            },
            tooltipTitle: {
              fontSize: 16,
              margin: "0 0 0px 0",
              textAlign: "left",
              paddingLeft: "0px",
              color: "transparent",
            },
            tooltipContent: {
              fontSize: 13,
              padding: "0px",
              textAlign: "left",
              fontWeight: 300,
              color: "transparent",
            },
            buttonNext: {
              fontSize: "13px",
            },
          }}
        />
      )} */}
      {/* {exploreFirstScreen && (
        <GuideOverlayTap exploreFirstScreen={exploreFirstScreen} run={run} setRun={setRun} />
      )} */}
    </div>
  );
});

export default memo(ExploreStory);
